<ng-container *ngIf='vm$ | async as vm'>
    <shared-ui-document-link *ngFor='let document of vm.documents$ | async' [entry]='document.entry'></shared-ui-document-link>
</ng-container>
